import { render, staticRenderFns } from "./VerApagarArquivo.vue?vue&type=template&id=91156d2a&scoped=true"
import script from "./VerApagarArquivo.vue?vue&type=script&lang=js"
export * from "./VerApagarArquivo.vue?vue&type=script&lang=js"
import style0 from "./VerApagarArquivo.vue?vue&type=style&index=0&id=91156d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91156d2a",
  null
  
)

export default component.exports